import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SelectedItem } from '@/shared/components/ui/selected-items-list/components/selected-item/selected-item';
import { SelectedItemsContainer } from '@/shared/components/ui/selected-items-list/selected-items-list.styled';
import { TSelectedItemList } from '@/shared/components/ui/selected-items-list/selected-items-list.types';

export const SelectedItemsList: React.FC<TSelectedItemList> = ({
  title,
  selectedItems,
  variant,
}) => {
  const { t } = useTranslation();

  if (!selectedItems || selectedItems.length === 0) {
    return null;
  }

  const getTitle = () => {
    if (title) {
      return title;
    }
    return t('ui:default_selected_items_title');
  };

  return (
    <>
      <Typography variant="p7">{getTitle()}</Typography>
      <SelectedItemsContainer gap="0.75rem">
        <Stack gap="0.5rem">
          {selectedItems.map((item, index) => (
            <SelectedItem
              key={`${item.name}-${index}`}
              {...item}
              variant={variant ?? item.variant}
            />
          ))}
        </Stack>
      </SelectedItemsContainer>
    </>
  );
};
